var _g, _rect, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_130_3299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 22,
    fill: "#85CDFD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 23,
    stroke: "white",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_130_3299",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 13,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 13,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_130_3299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5003 40.111C27.3448 40.111 28.0003 39.8888 28.467 39.4443C28.9337 38.9999 29.7781 38.7777 31.0003 38.7777C32.2077 38.7777 33.0577 38.9999 33.5503 39.4443C34.0429 39.8888 34.6966 40.111 35.5114 40.111C36.3559 40.111 37.0114 39.8517 37.4781 39.3332C37.9448 38.8147 38.7892 38.5554 40.0114 38.5554C40.8929 38.5554 41.5522 38.7054 41.9892 39.0054C42.4263 39.3054 42.8559 39.5703 43.2781 39.7999C43.5522 39.948 43.7966 40.1425 44.0114 40.3832C44.2262 40.624 44.3337 40.9036 44.3337 41.2221C44.3337 41.5406 44.2225 41.7999 44.0003 41.9999C43.7781 42.1999 43.5263 42.2554 43.2448 42.1665C42.5781 41.9739 42.0263 41.6943 41.5892 41.3276C41.1522 40.961 40.6262 40.7776 40.0114 40.7776C39.2485 40.7776 38.6114 41.0369 38.1003 41.5554C37.5892 42.074 36.7262 42.3332 35.5114 42.3332C34.2966 42.3332 33.4318 42.111 32.917 41.6665C32.4022 41.2221 31.7633 40.9999 31.0003 40.9999C30.2299 40.9999 29.5929 41.2221 29.0892 41.6665C28.5855 42.111 27.7225 42.3332 26.5003 42.3332C25.2781 42.3332 24.4151 42.111 23.9114 41.6665C23.4077 41.2221 22.7707 40.9999 22.0003 40.9999C21.4003 40.9999 20.8818 41.1536 20.4448 41.461C20.0077 41.7684 19.4633 42.011 18.8114 42.1888C18.5151 42.2628 18.2503 42.1999 18.017 41.9999C17.7837 41.7999 17.667 41.5406 17.667 41.2221C17.667 40.9036 17.7725 40.624 17.9837 40.3832C18.1948 40.1425 18.4448 39.9554 18.7337 39.8221C19.1559 39.6221 19.5874 39.398 20.0281 39.1499C20.4688 38.9017 21.1263 38.7777 22.0003 38.7777C23.2225 38.7777 24.067 38.9999 24.5337 39.4443C25.0003 39.8888 25.6559 40.111 26.5003 40.111ZM26.5003 36.111C25.2929 36.111 24.43 35.8888 23.9114 35.4443C23.3929 34.9999 22.7559 34.7776 22.0003 34.7776C21.4077 34.7776 20.8892 34.9313 20.4448 35.2387C20.0003 35.5462 19.4522 35.7888 18.8003 35.9665C18.504 36.0406 18.2411 35.9776 18.0114 35.7776C17.7818 35.5776 17.667 35.3184 17.667 34.9999C17.667 34.6814 17.7744 34.4017 17.9892 34.161C18.204 33.9202 18.4559 33.7332 18.7448 33.5999C19.167 33.3999 19.5966 33.1758 20.0337 32.9277C20.4707 32.6795 21.1226 32.5554 21.9892 32.5554C22.1966 32.5554 22.4077 32.5684 22.6226 32.5943C22.8374 32.6203 23.03 32.6591 23.2003 32.711L21.6448 27.0443L20.3448 28.6887C20.1522 28.9332 19.9077 29.0721 19.6114 29.1054C19.3151 29.1387 19.0448 29.0554 18.8003 28.8554C18.5485 28.6554 18.4059 28.4017 18.3726 28.0943C18.3392 27.7869 18.4226 27.511 18.6226 27.2665L27.0226 16.9221C27.3262 16.5517 27.7114 16.3054 28.1781 16.1832C28.6448 16.061 29.1003 16.0851 29.5448 16.2554L42.0114 20.9999C42.3003 21.1184 42.5077 21.3147 42.6337 21.5888C42.7596 21.8628 42.7633 22.1443 42.6448 22.4332C42.5262 22.7147 42.3244 22.9202 42.0392 23.0499C41.754 23.1795 41.4707 23.1851 41.1892 23.0665L39.2559 22.3221L42.067 32.7999C42.2744 32.911 42.4799 33.0369 42.6837 33.1776C42.8874 33.3184 43.0892 33.4443 43.2892 33.5554C43.5633 33.7184 43.8059 33.9202 44.017 34.161C44.2281 34.4017 44.3337 34.6814 44.3337 34.9999C44.3337 35.3184 44.2151 35.5776 43.9781 35.7776C43.7411 35.9776 43.4818 36.0332 43.2003 35.9443C42.5485 35.7369 42.004 35.4536 41.567 35.0943C41.1299 34.735 40.6114 34.5554 40.0114 34.5554C39.2411 34.5554 38.604 34.8147 38.1003 35.3332C37.5966 35.8517 36.7336 36.111 35.5114 36.111C34.304 36.111 33.4392 35.8888 32.917 35.4443C32.3948 34.9999 31.7559 34.7776 31.0003 34.7776C30.2299 34.7776 29.5929 34.9999 29.0892 35.4443C28.5855 35.8888 27.7225 36.111 26.5003 36.111ZM26.5003 33.8888C27.1818 33.8888 27.7651 33.7073 28.2503 33.3443C28.7355 32.9814 29.3411 32.7406 30.067 32.6221L28.9781 28.6332C28.9337 28.4851 28.9522 28.3443 29.0337 28.211C29.1151 28.0776 29.23 27.9888 29.3781 27.9443L33.0337 26.9777C33.1818 26.9332 33.3226 26.9517 33.4559 27.0332C33.5892 27.1147 33.6781 27.2295 33.7226 27.3776L35.4226 33.8777C36.2151 33.9221 36.8596 33.6906 37.3559 33.1832C37.8522 32.6758 38.6077 32.3962 39.6226 32.3443L36.667 21.311L28.767 18.311L23.3781 24.8887L25.7892 33.7999C25.9226 33.8369 26.0429 33.861 26.1503 33.8721C26.2577 33.8832 26.3744 33.8888 26.5003 33.8888Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_130_3299",
    x: 0.421053,
    y: 0.421053,
    width: 61.1579,
    height: 61.1579,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28947
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.53849 0 0 0 0 0.567513 0 0 0 0 0.6125 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_130_3299"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_130_3299",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlood);
export default __webpack_public_path__ + "static/media/flood.455f14c405589c34ecdf9f14a3f8c888.svg";
export { ForwardRef as ReactComponent };